<template>
<form @submit.prevent="repackJob()">
  <cytomine-modal :active="active" :title="job.softwareName" @close="$emit('update:active', false)">
    <b-loading :is-full-page="false" :active="loading" />
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th></th>
          <th>{{$t('name')}}</th>
          <th>{{$t('value')}}</th>
        </tr>
      </thead>
      <tbody>
        <job-parameter-row
          v-for="param in inputs"
          :param="param"
          :key="param.id"
          v-model="param.value"
        />
      </tbody>
    </table>

    <template #footer>
      <button class="button" type="button" @click="$emit('update:active', false)">
        {{$t('button-cancel')}}
      </button>
      <button class="button is-link" :disabled="errors.any()">
        {{$t('publish-trained-job')}}
      </button>
    </template>
  </cytomine-modal>
</form>
</template>

<script>
import axios from 'axios';

import CytomineModal from '@/components/utils/CytomineModal';
import CytomineMultiselect from '@/components/form/CytomineMultiselect';
import JobParameterRow from './JobParameterRow';

export default {
  name: 'repack-job-modal',
  props: {
    active: Boolean,
    job: Object
  },
  components: {
    CytomineModal,
    CytomineMultiselect,
    JobParameterRow
  },
  $_veeValidate: {validator: 'new'},
  data() {
    return {
      loading: false,
      inputs: [
        {
          id: 'version',
          humanName: this.$t('version'),
          type: 'String',
          defaultParamValue: this.job.softwareName.split(' (')[1].split(')')[0].split('_')[0],
          value: ''
        },
        {
          id: 'training-algorithms',
          humanName: this.$t('training-algorithms'),
          type: 'Boolean',
          value: true
        }
      ]
    };
  },
  watch: {
    active(val) {
      if(val) {
        this.selectedSoftware = null;
        this.showOptional = false;
        this.showPrefilled = false;
      }
    }
  },
  methods: {
    async repackJob() {
      const newVersion = this.inputs[0].value;
      const train = this.inputs[1].value;
      const uri = `/algorithms/from_job/${this.job.id}?version=${newVersion}&dry_run=false&train=${train ? 'true' : 'false'}`;
      this.loading = true;

      axios.post(uri)
        .then(response => {
          console.log(response);
          this.loading = false;
          this.$notify({
            type: 'success',
            text: this.$t('notif-success-algorithm-creation')
          });
          this.$emit('update:active', false);
        }).catch(error => {
          console.error(error);
          this.$notify({
            type: 'error',
            text: this.$t('notif-error-algorithm-creation')
          });
        });
    }
  }
};
</script>
